"use strict";
exports.__esModule = true;
var time_1 = require("../models/time");
var time_helpers_1 = require("../helpers/time-helpers");
exports.validatePair = function (openingHours) {
    if (!openingHours) {
        return '';
    }
    var from = openingHours.from, to = openingHours.to;
    if (!time_helpers_1.isValidTime(from) || !time_helpers_1.isValidTime(to)) {
        return 'Указан неверный формат';
    }
    if (time_helpers_1.toMinutes(from) >= time_helpers_1.toMinutes(to)) {
        return 'Указан некорректный промежуток';
    }
    return '';
};
exports.isEmptySchedule = function (openingHours) {
    var weekdays = Object.keys(openingHours);
    for (var _i = 0, weekdays_1 = weekdays; _i < weekdays_1.length; _i++) {
        var day = weekdays_1[_i];
        if (openingHours[day] !== null) {
            return false;
        }
    }
    return true;
};
var validateOpeningHours = function (openingHours) {
    var error;
    for (var _i = 0, days_1 = time_1.days; _i < days_1.length; _i++) {
        var day = days_1[_i];
        error = exports.validatePair(openingHours[day]);
        if (error) {
            return error;
        }
    }
    if (exports.isEmptySchedule(openingHours)) {
        return 'Выберите рабочие дни';
    }
    return '';
};
exports["default"] = validateOpeningHours;
